<template>
  <div class="container single">
    <common-step-bar :current-step="confirm ? 2 : 1" class="marginY4" />
    <client-only>
      <div v-if="!confirm">
        <h1 class="pageTitle marginY3" :class="{ 'pageTitle--no-border': abGroup === 'B' }">{{ pageTitle }}</h1>
        <div class="purchaseForm">
          <!-- 開催中イベントの案内（開始時刻を過ぎている場合のみ表示 / A/B 両パターン共通） -->
          <PurchaseOngoingEventNotice :event="event" />
          <payment-status-notification-message v-if="payment_status_notification" :payment-status-notification="payment_status_notification" />
          <div class="paddingX3">
            <common-flash-message />
            <flash-message v-if="errorMessages" :messages="errorMessages" type="error" />
            <flash-message v-if="warningMessage" :message="warningMessage" type="warning" />
          </div>
          <!-- 名前入力フォーム（名前未入力の場合のみ表示） -->
          <div v-if="user.needs_name_register" class="nameInputSection marginY4">
            <h2 class="textBold textLarge marginB2">名前の入力</h2>
            <div class="purchaseCard commonCard">
              <div class="paddingX4 paddingY3">
                <UserProfileForm
                  ref="userProfileForm"
                  :initial-profile-data="nameForm"
                  :age-conditions="{}"
                  :name-only="true"
                  @update-name="onUpdateNameForm"
                />
              </div>
            </div>
          </div>

          <!-- Pattern B: Event Info Card -->
          <PurchaseEventInfoCard
            v-if="abGroup === 'B'"
            :event="event"
            :event-organization-time="eventOrganizationTime"
            :event-start-today="eventStartToday"
            class="marginY4 event-info card-layout card-layout--no-shadow"
          />

          <!-- Pattern A: 申込内容 (Event info + quantity + full price breakdown in one card) -->
          <template v-if="abGroup !== 'B'">
            <h2 class="textBold textLarge marginB2">申込内容</h2>
            <div class="purchaseCard commonCard">
              <div v-if="event.konkatsu_freepass || event.mens_pass" class="purchaseCard-subscription padding4">{{ event.event_title }}</div>
              <div v-else class="purchaseCard-event paddingX4 paddingY3">
                <div class="purchaseCard-event-box">
                  <img :src="event.eyecatch" class="purchaseCard-event-box-eyecatch" />
                  <div class="purchaseCard-event-box-block">
                    <span v-if="!event.konkatsu_freepass && !event.mens_pass" class="textBold"
                      >{{ eventOrganizationTime }}<span v-if="eventTimeRange">{{ eventTimeRange }}</span
                      ><!-- mj-issues#776: 開始日と終了日が異なる場合は終了日時を折り返して表示する
                      --><template v-if="eventEndDateTime"><br />{{ eventEndDateTime }}</template>
                      <div v-if="eventStartToday" class="purchaseCard-event-box-block-today">本日開催</div></span
                    ><br />
                    <span class="purchaseCard-event-box-block-area">{{ event.prefecture_name }} / {{ event.area_name }}</span>
                  </div>
                </div>
                <div class="purchaseCard-event-title marginT3">{{ event.event_title }}</div>
              </div>
              <div class="purchaseCard-priceData">
                <dl ref="priceDataElement" class="priceData marginX4 marginY3">
                  <div v-if="!event.konkatsu_freepass && !event.mens_pass" class="priceData-item paddingB2">
                    <dt class="priceData-item-term">購入枚数</dt>
                    <dd v-if="!ticket.original_stage_ticket_id" class="priceData-item-desc">
                      <select
                        v-if="canSelectQuantity"
                        v-model="model.quantity"
                        class="commonInput"
                        @click="onClickQuantitySelect"
                        @change="onChangeQuantity"
                      >
                        <option v-for="(quantity, index) in quantitySelectOptions" :key="index" :value="quantity.value" :disabled="quantity.disabled">
                          {{ quantity.text }}
                        </option>
                      </select>
                      <template v-else-if="alreadyPurchasedSoloEvent">
                        <select disabled class="commonInput" style="opacity: 0.5">
                          <option>1枚</option>
                        </select>
                        <p class="marginT2" style="color: #e74c3c; font-size: 12px">
                          既にチケットを申込済です。お申込みチケットは<a :href="purchasedTicketUrl">こちら</a>。
                        </p>
                      </template>
                      <template v-else>
                        1枚
                        <p v-if="isMarriageMemberEvent && !isMdgMemberPartyEvent">このイベントは1枚しか購入できません</p>
                      </template>
                    </dd>
                    <dd v-else class="priceData-item-desc">
                      <select
                        v-if="canSelectQuantity"
                        v-model="model.quantity"
                        class="commonInput"
                        @click="onClickQuantitySelect"
                        @change="onChangeQuantity"
                      >
                        <option v-for="(quantity, index) in quantitySelectOptions" :key="index" :value="quantity.value">
                          {{ quantity.text }}
                        </option>
                      </select>
                      <template v-else-if="alreadyPurchasedSoloEvent">
                        <select disabled class="commonInput" style="opacity: 0.5">
                          <option>1枚</option>
                        </select>
                        <p class="marginT2" style="color: #e74c3c; font-size: 12px">
                          既にチケットを申込済です。お申込みチケットは<a :href="purchasedTicketUrl">こちら</a>。
                        </p>
                      </template>
                      <template v-else>
                        1枚
                        <p v-if="isMarriageMemberEvent && !isMdgMemberPartyEvent">このイベントは1枚しか購入できません</p>
                      </template>
                    </dd>
                    <div v-show="displayTooltip && needDisplayTooltip" class="priceData-item-tooltip">
                      <div class="priceData-item-tooltip-inner">{{ tooltipText }}</div>
                    </div>
                  </div>
                  <div v-if="hasGroupDiscount" class="priceData-item paddingY2">
                    <div></div>
                    <div class="priceData-item-group-discount paddingY2">複数枚購入で割引あり！</div>
                  </div>
                  <div class="priceData-item paddingY2">
                    <dt class="priceData-item-term">{{ ticketName }}</dt>
                    <dd v-if="model.ticket_type === 'konkatsu_freepass' || model.ticket_type === 'mens_pass'" class="priceData-item-desc">
                      <s>{{ ticketPrice }}</s>
                      {{ model.ticket_type === 'konkatsu_freepass' ? numberToCurrency(0) : numberToCurrency(ticketPriceAfterMenspassDiscount) }}
                    </dd>
                    <dd v-else class="priceData-item-desc">
                      <template v-if="!ticket.original_stage_ticket_id">
                        {{ ticketPrice }}
                      </template>
                      <template v-else>
                        <span class="price">{{ ticketPrice }}</span>
                        <span class="originPrice">{{ originStageTicketPrice }}</span>
                      </template>
                    </dd>
                  </div>
                  <div v-if="isSelectedGroupDiscount" class="priceData-item paddingY2">
                    <dt class="priceData-item-term">小計</dt>
                    <dd class="priceData-item-desc">{{ numberToCurrency(totalOriginStageTicketPrice) }}</dd>
                  </div>
                  <div v-if="event.goto_campaign_event" class="priceData-item paddingY2">
                    <dt class="priceData-item-term">Go Toイベント割引</dt>
                    <dd class="priceData-item-desc">{{ gotoEventTicketDiscount }}</dd>
                  </div>
                  <div v-if="model.ticket_type === 'konkatsu_freepass'" class="priceData-item paddingY2">
                    <dt class="priceData-item-term">婚活フリーパス月額コース</dt>
                    <dd class="priceData-item-desc">{{ numberToCurrency(ticket.konkatsu_freepass_ticket_price) }}</dd>
                  </div>
                  <div v-if="ticket.mens_pass_discount_price && !canBuyWithMenspass" class="priceData-item paddingY2">
                    <dt class="priceData-item-term">割引(メンズパス)</dt>
                    <dd class="priceData-item-desc">- {{ numberToCurrency(ticket.mens_pass_discount_price) }}</dd>
                  </div>
                  <div v-if="model.ticket_type === 'mens_pass'" class="priceData-item paddingY2">
                    <dt class="priceData-item-term">メンズパス</dt>
                    <dd class="priceData-item-desc">{{ numberToCurrency(ticket.mens_pass_price) }}</dd>
                  </div>
                  <transition name="fade">
                    <div v-if="discountAmount" class="priceData-item paddingY2 priceData-discountAmount">
                      <dt class="priceData-item-term">割引</dt>
                      <dd class="priceData-item-desc">-{{ numberToCurrency(discountAmount) }}</dd>
                    </div>
                  </transition>
                  <div v-if="isSelectedGroupDiscount" class="priceData-item paddingY2 priceData-discountAmount">
                    <dt class="priceData-item-term">グループ割引</dt>
                    <dd class="priceData-item-desc">-{{ numberToCurrency(groupDiscountAmount) }}</dd>
                  </div>
                  <div v-if="model.include_repeat_discount" class="priceData-item paddingY2">
                    <dt class="priceData-item-term">500円OFFリピート券2枚</dt>
                    <dd class="priceData-item-desc">{{ numberToCurrency(500) }}</dd>
                  </div>
                  <div v-if="model.use_repeat_discount" class="priceData-item paddingY2 priceData-discountAmount">
                    <dt class="priceData-item-term">リピート券割引</dt>
                    <dd class="priceData-item-desc">-{{ numberToCurrency(500) }}</dd>
                  </div>
                  <div class="priceData-item paddingY2">
                    <dt class="priceData-item-term">合計</dt>
                    <dd class="priceData-item-desc">
                      <template v-if="!ticket.original_stage_ticket_id && !isSelectedGroupDiscount">
                        {{ numberToCurrency(ticketTotalPrice) }}
                      </template>
                      <template v-else>
                        <span class="price">{{ numberToCurrency(ticketTotalPriceWithGroupDiscount) }}</span>
                        <span class="originPrice">{{ numberToCurrency(totalOriginStageTicketPrice) }}</span>
                      </template>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </template>

          <!-- Pattern B: 予約内容 (Simplified quantity + price breakdown) -->
          <template v-else>
            <h2 class="textBold textLarge marginB2 marginT5">予約内容</h2>
            <div class="purchaseCard card-layout">
              <div class="purchaseCard-priceData purchaseCard-priceData--pattern-b">
                <dl ref="priceDataElement" class="priceData">
                  <div v-if="!event.konkatsu_freepass && !event.mens_pass" class="priceData-item paddingB2">
                    <dt class="priceData-item-term">予約枚数</dt>
                    <dd v-if="!ticket.original_stage_ticket_id" class="priceData-item-desc">
                      <select
                        v-if="canSelectQuantity"
                        v-model="model.quantity"
                        class="commonInput"
                        @click="onClickQuantitySelect"
                        @change="onChangeQuantity"
                      >
                        <option v-for="(quantity, index) in quantitySelectOptions" :key="index" :value="quantity.value" :disabled="quantity.disabled">
                          {{ quantity.text }}
                        </option>
                      </select>
                      <template v-else>
                        1枚
                        <p v-if="isMarriageMemberEvent && !isMdgMemberPartyEvent">このイベントは1枚しか購入できません</p>
                      </template>
                    </dd>
                    <dd v-else class="priceData-item-desc">
                      <select
                        v-if="canSelectQuantity"
                        v-model="model.quantity"
                        class="commonInput"
                        @click="onClickQuantitySelect"
                        @change="onChangeQuantity"
                      >
                        <option v-for="(quantity, index) in quantitySelectOptions" :key="index" :value="quantity.value">
                          {{ quantity.text }}
                        </option>
                      </select>
                      <template v-else>
                        1枚
                        <p v-if="isMarriageMemberEvent && !isMdgMemberPartyEvent">このイベントは1枚しか購入できません</p>
                      </template>
                    </dd>
                    <div v-show="displayTooltip && needDisplayTooltip" class="priceData-item-tooltip">
                      <div class="priceData-item-tooltip-inner">{{ tooltipText }}</div>
                    </div>
                  </div>
                  <div v-if="hasGroupDiscount" class="priceData-item paddingY2">
                    <div></div>
                    <div class="priceData-item-group-discount paddingY2">複数枚購入で割引あり！</div>
                  </div>
                  <div class="priceData-item paddingY2">
                    <dt class="priceData-item-term">{{ ticketName }}</dt>
                    <dd class="priceData-item-desc">
                      <template v-if="!ticket.original_stage_ticket_id">
                        {{ ticketPrice }}
                      </template>
                      <template v-else>
                        <span class="price">{{ ticketPrice }}</span>
                        <span class="originPrice">{{ originStageTicketPrice }}</span>
                      </template>
                    </dd>
                  </div>
                  <div v-if="isSelectedGroupDiscount" class="priceData-item paddingY2">
                    <dt class="priceData-item-term">小計</dt>
                    <dd class="priceData-item-desc">{{ numberToCurrency(totalOriginStageTicketPrice) }}</dd>
                  </div>
                  <div v-if="event.goto_campaign_event" class="priceData-item paddingY2">
                    <dt class="priceData-item-term">Go Toイベント割引</dt>
                    <dd class="priceData-item-desc">{{ gotoEventTicketDiscount }}</dd>
                  </div>
                  <div v-if="isSelectedGroupDiscount" class="priceData-item priceData-discountAmount paddingY2">
                    <dt class="priceData-item-term">グループ割引</dt>
                    <dd class="priceData-item-desc">-{{ numberToCurrency(groupDiscountAmount) }}</dd>
                  </div>
                  <transition name="fade">
                    <div v-if="discountAmount" class="priceData-item paddingY2 priceData-discountAmount">
                      <dt class="priceData-item-term">割引</dt>
                      <dd class="priceData-item-desc">-{{ numberToCurrency(discountAmount) }}</dd>
                    </div>
                  </transition>
                  <div v-if="model.include_repeat_discount" class="priceData-item paddingY2">
                    <dt class="priceData-item-term">500円OFFリピート券2枚</dt>
                    <dd class="priceData-item-desc">{{ numberToCurrency(500) }}</dd>
                  </div>
                  <div v-if="model.use_repeat_discount" class="priceData-item paddingY2 priceData-discountAmount">
                    <dt class="priceData-item-term">リピート券割引</dt>
                    <dd class="priceData-item-desc">-{{ numberToCurrency(500) }}</dd>
                  </div>
                  <div class="priceData-item paddingY2">
                    <dt class="priceData-item-term">合計</dt>
                    <dd class="priceData-item-desc">
                      <template v-if="!ticket.original_stage_ticket_id && !isSelectedGroupDiscount">
                        {{ numberToCurrency(ticketTotalPrice) }}
                      </template>
                      <template v-else>
                        <span class="price">{{ numberToCurrency(ticketTotalPriceWithGroupDiscount) }}</span>
                        <span class="originPrice">{{ numberToCurrency(totalOriginStageTicketPrice) }}</span>
                      </template>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </template>

          <CouponForm v-if="displayCouponFeature" v-model:couponCode="model.coupon_code" @apply-coupon="applyCouponCode" />
          <CustomQuestion
            v-if="event.custom_question1 || event.custom_question2"
            v-model:first-answer="model.custom_question_answer1"
            v-model:second-answer="model.custom_question_answer2"
            :first-question="event.custom_question1"
            :second-question="event.custom_question2"
          />

          <!-- 回数券オプション（対象ユーザーのみ表示） -->
          <RepeatDiscountOption v-model="model.include_repeat_discount" :should-show="shouldShowRepeatDiscountOption" />

          <!-- 回数券利用オプション（バックエンドから有効な回数券データがある場合のみ表示） -->
          <RepeatDiscountUsage
            v-if="user.repeat_discounts && user.repeat_discounts.length > 0"
            v-model="model.use_repeat_discount"
            :user-repeat-discounts="user.repeat_discounts"
            :ticket-price="ticket.price"
          />

          <PaymentMethods
            ref="PaymentMethods"
            v-model:paymentMethod="model.payment_method"
            v-model:ticketType="model.ticket_type"
            :title="paymentMethodTitle"
            :ticket="ticket"
            :event="event"
            :user="user"
            :is-free-ticket="isFreeTicket"
            :having-same-time-event-for-free-purchase="havingSameTimeEventForFreePurchase"
            :having-same-time-event-for-online-purchase="havingSameTimeEventForOnlinePurchase"
            :is-five-minutes-event="isFiveMinutesEvent"
            :is-marriage-member-event="isMarriageMemberEvent"
            :can-purchase-by-amazon-pay="canPurchaseByAmazonPay"
          />
          <TotalPrice
            :event="event"
            :model-quantity="model.quantity"
            :final-actual-price="finalActualPrice"
            :can-go-to-next-page="canGoToConfirmPage"
            :agree-provide-info="agreeProvideInfo"
            :is-marriage-member-event="isMarriageMemberEvent"
            :payment-method="model.payment_method"
            :purchase-path="purchasePath"
            @update-agree-provide-info="onUpdateAgreeProvideInfo"
            @to-next-page="toPurchaseConfirm"
          />
          <button class="cancelLink marginT4" @click="browserBackToEventDetail">戻る</button>
        </div>
      </div>
      <purchase-confirmation
        v-else
        :model="model"
        :ticket="ticket"
        :event="event"
        :stripe-payment-token="stripePaymentToken"
        :action-logs="actionLogs"
        :user="user"
        :name-form="nameForm"
        @go-back="backToNewPage"
      />
    </client-only>

    <!-- 回数券モーダル -->
    <RepeatDiscountModal
      :should-show-modal="shouldShowRepeatDiscountModal()"
      @close-modal="closeRepeatDiscountModal"
      @purchase-with-repeat-discount="handlePurchaseWithRepeatDiscount"
      @purchase-without-repeat-discount="handlePurchaseWithoutRepeatDiscount"
    />

    <PurchaseSetSaleToast v-model:show="showSetSaleToast" />
  </div>
</template>

<script>
import { getKonkatsuCouponCodeForLpPage } from '@/utils/coupon'
import { numberToCurrency, timeConverter } from '@/utils/converter'
import { scrollTo, scrollToTop } from '@/utils/ScrollTo'
import OnlineEventMixin from '@/utils/mixins/OnlineEventMixin'
import ChocomEmoneyMixin from '@/utils/mixins/ChocomEmoneyMixin'
import PurchaseMixin from '@/utils/mixins/PurchaseMixin'
import BrowserBackMixin from '@/utils/mixins/BrowserBackMixin'
import GTM from '@/utils/tracking/gtm'
import { pushAdAddToCart } from '@/utils/tracking/adCheckoutEvents'
import CriteoGtmDatalayer from '@/utils/CriteoGtmDatalayer'
import BrowserStorage from '@/utils/BrowserStorage'
import {
  shouldDisablePurchaseButton,
  isSoloParticipationEvent,
  alreadyPurchasedSoloEventMessage,
  purchasedTicketPath
} from '@/utils/purchaseValidation'
import { useMainStore } from '@/store'
import { getSetQuantities, isOnlySetSale } from '@/utils/purchase/setTicketSale'
import { eventEndDateTimeText, eventTimeRangeText } from '@/utils/purchase/eventSchedule'
import { normalizeQuantityForTicket } from '@/utils/purchase/normalizeQuantityForTicket'
import { useRoute } from 'vue-router'
import { useNuxtApp } from '#app'
import { reactive } from 'vue'
import { callWithNuxt } from 'nuxt/app'
import useABTestV2 from '@/utils/abtest/useABTestV2'
import { REPEAT_DISCOUNT_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import { sendRepeatDiscountViewEvent } from '@/utils/abtest/repeatDiscountGAEvent'
import { PENDING_NAME_STORAGE_KEY } from '@/utils/constants/purchase'
import { useIssue616AbTest } from '@/composables/useIssue616AbTest'
import Cookies from 'mj-cookie'
const FlashMessage = defineAsyncComponent(() => import('@/components/FlashMessage.vue'))
const PurchaseConfirmation = defineAsyncComponent(() => import('@/components/purchase/PurchaseConfirmation.vue'))
const CommonFlashMessage = defineAsyncComponent(() => import('@/components/CommonFlashMessage.vue'))
const CommonStepBar = defineAsyncComponent(() => import('@/components/CommonStepBar.vue'))
const PaymentStatusNotificationMessage = defineAsyncComponent(() => import('@/components/purchase/PaymentStatusNotificationMessage.vue'))
const CouponForm = defineAsyncComponent(() => import('@/components/purchase/CouponForm.vue'))
const CustomQuestion = defineAsyncComponent(() => import('@/components/purchase/CustomQuestion.vue'))
const PaymentMethods = defineAsyncComponent(() => import('@/components/purchase/PaymentMethods.vue'))
const TotalPrice = defineAsyncComponent(() => import('@/components/purchase/TotalPrice.vue'))
const RepeatDiscountModal = defineAsyncComponent(() => import('@/components/modals/RepeatDiscountModal.vue'))
const RepeatDiscountUsage = defineAsyncComponent(() => import('@/components/purchase/RepeatDiscountUsage.vue'))
const RepeatDiscountOption = defineAsyncComponent(() => import('@/components/purchase/RepeatDiscountOption.vue'))
const UserProfileForm = defineAsyncComponent(() => import('@/components/purchase/UserProfileForm.vue'))

const CVS_COMMISSION = 330
const MONTHS_IN_YEAR = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
const DEFAULT_COMPONENT_DATA = {
  useCoupon: false,
  couponCode: null,
  confirm: false,
  displayTooltip: false
}
export default {
  components: {
    FlashMessage,
    PurchaseConfirmation,
    CommonFlashMessage,
    CommonStepBar,
    PaymentStatusNotificationMessage,
    CouponForm,
    CustomQuestion,
    PaymentMethods,
    TotalPrice,
    RepeatDiscountModal,
    RepeatDiscountUsage,
    RepeatDiscountOption,
    UserProfileForm
  },
  mixins: [OnlineEventMixin, PurchaseMixin, BrowserBackMixin, ChocomEmoneyMixin],
  async setup() {
    const { abGroup, sendOnPaymentPageClick } = usePaymentFlowABTest()
    const { track: trackIssue616Event } = useIssue616AbTest()

    const app = useNuxtApp()
    const store = useMainStore()
    const route = useRoute()
    const params = route.params
    const query = route.query
    const shouldOpenConfirm = query.confirm !== 'false'
    const requests = []
    const payload = { eventCode: params.code, ticketId: params.ticket_id, quantity: query.quantity }
    const criteoGtmDatalayer = new CriteoGtmDatalayer(store)
    definePageMeta({
      middleware: [
        function (to) {
          const store = useMainStore()
          if (store.$state.auth_info) return

          const isSpecialPass =
            to.params.code === import.meta.env.KONKATSU_FREEPASS_EVENT_CODE || to.params.code === import.meta.env.MENSPASS_EVENT_CODE
          // TODO: Add (params.code !== 'aCYmCg') to following condition for test on production
          if (isSpecialPass) {
            const redirectPathQuery = `?cb_redirect_path=${encodeURIComponent(to.fullPath)}`
            return navigateTo(
              `${import.meta.env.LINKBAL_ID_IDP_URL}/v2/login?client_id=${import.meta.env.LINKBAL_ID_CLIENT_ID}&${redirectPathQuery}`,
              { external: true }
            )
          }
          return navigateTo(`/events/${to.params.code}/tickets/${to.params.ticket_id}/purchase_options/?quantity=${to.query.quantity || 1}`)
        }
      ],
      layout: 'simple'
    })
    if (query['purchase[coupon_code]']) {
      payload.couponCode = query['purchase[coupon_code]']
      payload.applyCoupon = true
    }
    if (query['purchase[quantity]']) payload.quantity = query['purchase[quantity]']
    // If user not set profile or name, store redirect path to session in server side to redirect back
    const myProfile = store.$state.my_profile
    if (!myProfile || !myProfile.filled_profile || !myProfile.name) {
      payload.redirectPath = route.fullPath
    }
    const purchaseRequest = store.dispatch('purchaseNew', payload).then(response => {
      const resData = response.data
      if (resData.redirect_path) return callWithNuxt(app, () => navigateTo(resData.redirect_path))
      const data = {
        errorMessages: resData.error_messages || null,
        canBuyWithMenspass: resData.can_buy_with_mens_pass,
        ticket: resData.ticket,
        event: resData.event,
        user: resData.user,
        alreadyBoughtWithMensPass: resData.already_purchased_with_mens_pass,
        konkatsuFreePassId: resData.event_konkatsu_freepass_id,
        soloParticipationOnly: isSoloParticipationEvent(resData.event.event_title),
        alreadyPurchasedSoloEvent: isSoloParticipationEvent(resData.event.event_title) && (resData.already_purchased_solo_event || false),
        alreadyPurchasedEventPurchaseId: resData.already_purchased_event_purchase_id || null
      }
      if (payload.applyCoupon && !data.errorMessages) {
        data.useCoupon = true
        data.couponCode = payload.couponCode
        if (shouldOpenConfirm) {
          data.confirm = true
        }
      }

      if (query.after_outer_login) {
        const queryParamMessage = 'チケットの購入が中断されたため、再度購入手続きをお願いします。'
        if (data.errorMessages) {
          data.errorMessages.push(queryParamMessage)
        } else {
          data.errorMessages = [queryParamMessage]
        }
      }

      if (query.message === 'paypay_expired') {
        data.errorMessages = ['PayPay決済の有効期限が切れました。再度お支払いをお願いします。']
      }

      if (query.message === 'paypay_update_failed') {
        data.errorMessages = ['PayPay決済の更新に失敗しました。再度お支払いをお願いします。']
      }

      data.warningMessage = data.alreadyBoughtWithMensPass ? 'メンズパスで購入済み' : ''
      if (data.alreadyPurchasedSoloEvent) {
        const soloMessage = alreadyPurchasedSoloEventMessage(data.alreadyPurchasedEventPurchaseId)
        data.errorMessages = data.errorMessages ? [...data.errorMessages, soloMessage] : [soloMessage]
      }
      return { ...DEFAULT_COMPONENT_DATA, ...data }
    })
    const paymentStatusNotificationRequest = store.dispatch('apiGet', 'payment_status_notifications').then(res => {
      return {
        payment_status_notification: res.data.payment_status_notification
      }
    })
    requests.push(purchaseRequest)
    requests.push(paymentStatusNotificationRequest)
    requests.push(criteoGtmDatalayer.fetchData())

    try {
      const [mainContents, paymentStatusNotificationContents, gtmContents] = await Promise.all(requests)
      return reactive({
        ...mainContents,
        ...paymentStatusNotificationContents,
        ...gtmContents,
        abGroup,
        sendOnPaymentPageClick,
        trackIssue616Event
      })
    } catch (e) {
      const errorCode = parseInt(e.response && e.response.status)
      await app.$error(errorCode)
    }
  },
  data: function () {
    // A/Bテストの実行
    const repeatDiscountABTest = useABTestV2(REPEAT_DISCOUNT_AB_TEST_CONFIG)

    return {
      ...DEFAULT_COMPONENT_DATA,
      model: {
        quantity: null,
        using_point: 0,
        coupon_code: null,
        verified_coupon_code: null,
        payment_method: null,
        ticket_type: null,
        custom_question_answer1: null,
        custom_question_answer2: null,
        include_repeat_discount: false,
        use_repeat_discount: false
      },
      showCvcTooltip: false,
      purchaseProductsKey: 'criteo_purchase_products',
      stripePaymentToken: {},
      agreeProvideInfo: false,
      actionLogs: [],
      includeRepeatDiscount: false,
      hasVisitedConfirmation: false, // 確認画面に一度でも進んだかどうか
      showSetSaleToast: false,
      // A/Bテスト結果
      repeatDiscountABTest,
      // 名前入力フォーム関連
      nameForm: {
        family_name: '',
        given_name: ''
      },
      pendingNameStorageKey: PENDING_NAME_STORAGE_KEY
    }
  },
  computed: {
    ticketSetSaleInfo() {
      const event = this.event || {}
      return {
        has_ticket_set_sale: event.has_ticket_set_sale || false,
        ticket_set_sale_settings: event.ticket_set_sale_settings || []
      }
    },
    onlySetSale() {
      return isOnlySetSale(this.ticketSetSaleInfo)
    },
    setQuantities() {
      return getSetQuantities(this.ticketSetSaleInfo)
    },
    enabledQuantities() {
      return (this.quantitySelectOptions || []).filter(option => !option.disabled).map(option => option.value)
    },
    minQuantityCap() {
      const capCandidates = [this.ticket?.available_quantity, this.ticket?.selectable_quantity_max, this.ticket?.stage_ticket_available_quantity]
        .map(Number)
        .filter(value => Number.isFinite(value) && value > 0)
      return capCandidates.length ? Math.min(...capCandidates) : null
    },
    shouldDisablePurchaseButtonForPatternB() {
      if (this.abGroup !== 'B') return false
      if (!this.ticket || !this.event) return true
      if (this.onlySetSale && this.setQuantities.length > 0) {
        const minSetQuantity = Math.min(...this.setQuantities)
        if (Number(this.ticket.available_quantity) < minSetQuantity) return true
      }
      return shouldDisablePurchaseButton(this.ticket, this.event)
    },
    pageTitle() {
      return this.abGroup === 'B' ? 'イベント参加予約' : '購入方法の選択'
    },
    paymentMethodTitle() {
      return this.abGroup === 'B' ? '決済方法選択' : '決済方法'
    },
    purchasePath() {
      return `/events/${this.$route.params.code}/tickets/${this.$route.params.ticket_id}`
    },
    canPurchaseByAmazonPay() {
      // Amazon Pay is only available in Pattern B
      if (this.abGroup !== 'B') return false

      // Pattern B: Hide Amazon Pay if stripe easy payment exists
      if (this.user.active_setup_intent_exists) return false

      // Allow Amazon Pay if not a five minutes event, not in native app, and not a free ticket
      if (this.ticket && this.ticket.price === 0) return false
      return !(this.isFiveMinutesEvent || this.$store.$state.native_app)
    },
    ticketName() {
      if (this.event.konkatsu_freepass || this.event.mens_pass) {
        return this.event.event_title.replace(/(婚活フリーパス|メンズパス)/, '')
      }
      return `${this.ticket.name}チケット`
    },
    discountAmount() {
      if (!this.ticket.coupon_discount_price || this.ticket.coupon_discount_price <= 0) return null
      return this.ticket.coupon_discount_price
    },
    groupDiscountAmount() {
      if (!this.ticket.group_discounts || this.model.quantity === 1) return 0
      const genderGroupDiscounts = this.ticket.group_discounts.filter(d => d.gender === this.myGender)
      const discountData = genderGroupDiscounts.find(d => d.applicable_person_count === this.model.quantity)
      return discountData.discount_price
    },
    myGender() {
      return this.$store.myGender
    },
    monthsInYear() {
      return MONTHS_IN_YEAR
    },
    ticketPriceAfterMenspassDiscount() {
      const price = this.purchasePrice - Number(this.ticket.mens_pass_discount_price)
      return price < 0 ? 0 : price
    },
    ticketRegularPrice() {
      return this.purchasePrice * this.model.quantity
    },
    commissionFee() {
      return this.model.payment_method === 'stripe_cvs' ? CVS_COMMISSION : 0
    },
    ticketTotalPriceBeforeUsePoint() {
      if (this.model.ticket_type === 'konkatsu_freepass') return this.ticket.konkatsu_freepass_ticket_price
      if (this.model.ticket_type === 'mens_pass') {
        const totalPrice =
          this.ticketRegularPrice + this.ticket.mens_pass_price - this.ticket.coupon_discount_price - Number(this.ticket.mens_pass_discount_price)
        return totalPrice > 0 ? totalPrice : 0
      }

      if (this.ticket.mens_pass_discount_price && !this.canBuyWithMenspass) {
        const totalPrice = this.ticketRegularPrice - Number(this.ticket.mens_pass_discount_price) - this.ticket.coupon_discount_price
        return totalPrice > 0 ? totalPrice : 0
      }
      return this.canPurchaseWithKonkatsuFreepass ? 0 : this.ticketRegularPrice - this.ticket.coupon_discount_price
    },
    ticketTotalPrice() {
      let totalPrice = this.ticketTotalPriceBeforeUsePoint - this.model.using_point
      // 回数券が選択されている場合は500円を追加
      if (this.model.include_repeat_discount) {
        totalPrice += 500
      }
      // 回数券利用時は500円割引
      if (this.model.use_repeat_discount) {
        totalPrice -= 500
      }
      return totalPrice > 0 ? totalPrice : 0
    },
    ticketTotalPriceWithGroupDiscount() {
      return this.ticketTotalPrice - this.groupDiscountAmount
    },
    finalActualPrice() {
      if (this.isFreeTicket) return 0
      return this.ticketTotalPriceWithGroupDiscount + this.commissionFee
    },
    totalOriginStageTicketPrice() {
      const ticketPrice = this.ticket.original_stage_ticket_price || this.ticket.price
      return ticketPrice * this.model.quantity
    },
    eventOrganizationTime() {
      if (this.event.event_type === 'bar_gourmet') {
        const startAt = timeConverter(this.event.start_at).fullDate
        const endAt = timeConverter(this.event.end_at).fullDate
        return startAt === endAt ? `${startAt}〜` : `${startAt}〜${endAt}`
      }
      const startDate = timeConverter(this.event.start_at).fullDateWithoutYear
      return `${startDate} `
    },
    // mj-issues#776: 開催日の隣に開始〜終了時刻を表示する（Pattern A のインラインカード用）
    eventTimeRange() {
      return eventTimeRangeText(this.event)
    },
    // mj-issues#776: 日跨ぎ開催は終了日時を次の行に表示する（Pattern A のインラインカード用）
    eventEndDateTime() {
      return eventEndDateTimeText(this.event)
    },
    eventStartToday() {
      if (this.event.event_type === 'bar_gourmet') return false
      const today = timeConverter().dateTime
      return today.isSameOrAfter(this.event.start_at, 'day') && today.isSameOrBefore(this.event.end_at, 'day')
    },
    isFreeTicket() {
      return Number(this.ticketTotalPrice) === 0 && Number(this.model.quantity) !== 0
    },
    quantitySelectOptions() {
      const list = []
      const unavailableText = this.ticket.original_stage_ticket_id ? '△ 通常チケット価格在庫あり' : '✖'
      const buildOption = value => ({
        value,
        text: `${value}枚 ${value > this.ticket.available_quantity ? `${unavailableText}` : '〇'}`,
        disabled: value > this.ticket.available_quantity
      })

      if (this.soloParticipationOnly) {
        return [buildOption(1)]
      }

      /* セット販売の最小在庫チェックは別ロジックで行う（ここでは未対応） */
      if (this.onlySetSale && this.setQuantities.length > 0) {
        return this.setQuantities.map(buildOption)
      }

      const maxQuantity = this.ticket.selectable_quantity_max
      for (let i = 1; i <= maxQuantity; i++) {
        list.push(buildOption(i))
      }
      return list
    },
    canSelectQuantity() {
      if (this.soloParticipationOnly) return false
      return (
        !this.isOnlineEvent &&
        !this.isOnlineServiceLinktextEvent &&
        (this.ticket.quantity_changeable || this.ticket.original_stage_ticket_id) &&
        !(this.event.konkatsu_freepass || this.canPurchaseWithKonkatsuFreepass) &&
        !this.event.mens_pass &&
        (!this.model.ticket_type || this.model.ticket_type === 'normal') &&
        (!this.isMarriageMemberEvent || this.isMdgMemberPartyEvent)
      )
    },
    displayCouponFeature() {
      return this.ticket.can_use_coupon_feature && !this.ticket.mens_pass_ticket_plan_monthly_auto_renew
    },
    canPurchaseWithKonkatsuFreepass() {
      return this.ticket.can_user_purchase_with_already_have_konkatsu_freepass
    },
    purchasedTicketUrl() {
      return purchasedTicketPath(this.alreadyPurchasedEventPurchaseId)
    },
    canGoToConfirmPage() {
      if (this.alreadyPurchasedSoloEvent) return false
      if (this.shouldDisablePurchaseButtonForPatternB) return false

      // 回数券使用で無料になった場合は進行を許可
      if (this.model.payment_method === 'free' && this.model.use_repeat_discount) return true
      if (this.model.payment_method === 'free' && this.havingSameTimeEventForFreePurchase) return false
      if (this.havingSameTimeEventForOnlinePurchase) return false
      if (this.isMarriageMemberEvent || this.event.provide_user_info_event) return this.model.payment_method && this.agreeProvideInfo
      return !!this.model.payment_method
    },
    freepassSixMonthsTicketPurchasePath() {
      if (!this.event.six_months_ticket_id) return ''
      return `/events/${this.$route.params.code}/tickets/${this.event.six_months_ticket_id}/purchases/new`
    },
    freepassThreeMonthsTicketPurchasePath() {
      if (!this.event.three_months_ticket_id) return ''
      return `/events/${this.$route.params.code}/tickets/${this.event.three_months_ticket_id}/purchases/new`
    },
    needDisplayTooltip() {
      if (this.soloParticipationOnly) return true
      return (
        (!this.ticket.quantity_changeable && !this.event.konkatsu_freepass && !this.event.mens_pass && !this.ticket.original_stage_ticket_id) ||
        this.model.quantity > 1
      )
    },
    chooseableYears() {
      const currentYear = new Date().getFullYear()
      return Array.from({ length: 15 }, (_, i) => currentYear + i)
    },
    tooltipText() {
      if (this.soloParticipationOnly) return '一人参加限定イベントのため、1枚のみ購入可能です'
      if (!this.ticket.quantity_changeable && !this.ticket.original_stage_ticket_id) return 'チケット残数が1枚のため複数購入することができません'
      if (this.model.quantity > 1) return 'まとめてご購入いただいたうち、一部のチケットのキャンセルはできません'
      return ''
    },
    localStorage() {
      return new BrowserStorage('localStorage')
    },
    isEasyPayment() {
      return ['stripe_cc_easy_payment', 'ntt_docomo_easy_payment'].includes(this.model.payment_method)
    },
    postedPaymentMethod() {
      return this.isEasyPayment ? this.model.payment_method.replace('_easy_payment', '') : this.model.payment_method
    },
    havingSameTimeEventForFreePurchase() {
      return this.user.having_same_time_event_for_free_purchase
    },
    havingSameTimeEventForOnlinePurchase() {
      return this.user.having_same_time_event_for_online_purchase
    },
    isMarriageMemberEvent() {
      return this.event.marriage_member_event
    },
    isMdgMemberPartyEvent() {
      return this.event.mdg_member_party_event
    },
    hasGroupDiscount() {
      return this.ticket.group_discounts
    },
    isSelectedGroupDiscount() {
      return this.hasGroupDiscount && this.model.quantity > 1
    },

    // 回数券オプションを表示するかどうか
    shouldShowRepeatDiscountOption() {
      // 基本条件：ログイン済み && 回数券対象ユーザー && A/Bテストでテストグループ
      return this.$store.isLoggedIn && this.user?.eligible_for_repeat_discount && this.repeatDiscountABTest.isBPattern
    },
    shouldDefaultToAmazonPay() {
      return (
        this.abGroup === 'B' && !this.user.active_setup_intent_exists && this.user.last_payment_method === 'amazon_pay' && this.canPurchaseByAmazonPay
      )
    }
  },
  watch: {
    '$route.query.m'(to, from) {
      if (this.$route.name != 'events-code-tickets-ticket_id-purchases-new') return
      if (!to && from) {
        this.confirm = false
        this.agreeProvideInfo = false
      }
    },
    isFreeTicket(to) {
      if (to) {
        this.model.payment_method = 'free'
      } else if (this.user.active_setup_intent_exists) {
        this.model.payment_method = 'stripe_cc_easy_payment'
      } else this.model.payment_method = 'stripe_cc'
    },
    'model.payment_method'() {
      this.actionLogs.push(`User choose payment method: ${this.model.payment_method}`)
    },
    'nameForm.family_name'() {
      this.handlePendingNameFormChange()
    },
    'nameForm.given_name'() {
      this.handlePendingNameFormChange()
    },
    'user.needs_name_register'(needsRegister) {
      if (!needsRegister) {
        this.clearPendingNameStorage()
      }
    }
  },
  created() {
    this.initModel()
  },
  mounted() {
    const loginMethod = Array.isArray(this.$route.query.login_method) ? this.$route.query.login_method[0] : this.$route.query.login_method
    if (loginMethod === 'line') {
      this.trackIssue616Event('line_login_completed')
    }

    this.setDefaultCouponCode()
    this.showAndHideTooltip()
    this.pushGtmData()
    // mj-issues#789: 広告ピクセルの AddToCart 用(割引前の チケット単価 × 枚数)
    pushAdAddToCart({ event: this.event, unitPrice: this.purchasePrice, quantity: this.model.quantity })

    // Send AB test payment page GA event
    this.sendOnPaymentPageClick()

    // 初回購入者の決済選択画面閲覧GA事業を送信
    if (this.$store.isLoggedIn && this.user?.eligible_for_repeat_discount) {
      sendRepeatDiscountViewEvent(this.$store, REPEAT_DISCOUNT_AB_TEST_CONFIG)
    }
  },
  methods: {
    numberToCurrency,
    setDefaultCouponCode() {
      if (this.event.konkatsu_freepass && !this.model.coupon_code) {
        this.model.coupon_code = getKonkatsuCouponCodeForLpPage() || this.$route.query.coupon_code || null
        if (this.model.coupon_code) this.useCoupon = true
      }
    },
    onUpdateNameForm(payload) {
      if (!payload) return
      this.nameForm.family_name = payload.family_name || ''
      this.nameForm.given_name = payload.given_name || ''
    },
    handlePendingNameFormChange() {
      if (import.meta.server) return
      if (!this.user.needs_name_register) {
        this.clearPendingNameStorage()
        return
      }
      const payload = {
        family_name: this.nameForm.family_name || '',
        given_name: this.nameForm.given_name || ''
      }
      if (!payload.family_name && !payload.given_name) {
        this.clearPendingNameStorage()
        return
      }
      this.localStorage.setItem(this.pendingNameStorageKey, JSON.stringify(payload))
    },
    clearPendingNameStorage() {
      if (import.meta.server) return
      this.localStorage.removeItem(this.pendingNameStorageKey)
    },
    initModel() {
      this.model.quantity = this.ticket.quantity || this.$route.query.quantity || 1
      if (this.onlySetSale && this.setQuantities.length > 0 && !this.setQuantities.includes(Number(this.model.quantity))) {
        this.model.quantity = Math.min(...this.setQuantities)
      }

      if (this.isFreeTicket) {
        this.model.payment_method = 'free'
      } else if (this.shouldDefaultToAmazonPay) {
        // Pattern B specific: Default to Amazon Pay if it was last payment method and no stripe easy payment
        this.model.payment_method = 'amazon_pay'
      } else if (this.user.active_setup_intent_exists) {
        this.model.payment_method = 'stripe_cc_easy_payment'
      } else {
        this.model.payment_method = 'stripe_cc'
      }

      if (this.canBuyWithMenspass) this.model.ticket_type = 'normal'
      if (this.couponCode) {
        this.model.coupon_code = this.couponCode
      }
    },
    onClickQuantitySelect() {
      if (this.onlySetSale && this.setQuantities.length > 0) {
        this.showSetSaleToast = true
      }
    },
    onChangeQuantity(e) {
      e.preventDefault()
      if (this.onlySetSale && this.setQuantities.length > 0 && !this.setQuantities.includes(Number(this.model.quantity))) {
        this.model.quantity = Math.min(...this.setQuantities)
      }
      this.actionLogs.push(`User changed quantity to ${this.model.quantity}`)
      if (this.model.quantity > this.ticket.available_quantity && this.ticket.original_stage_ticket_id) {
        const payload = { ticket: this.ticket }
        this.$store.MODAL({ name: 'StageTicketWarningModal', payload })
        this.model.quantity =
          this.ticket.available_quantity > this.ticket.selectable_quantity_max ? this.ticket.selectable_quantity_max : this.ticket.available_quantity
        this.fetchNewTicket()
      } else {
        this.fetchNewTicket()
        this.$router.push({ path: this.$route.path, query: { quantity: this.model.quantity } })
        if (this.model.quantity > 1) {
          this.showAndHideTooltip()
        }
      }
    },
    applyCouponCode(e) {
      e.preventDefault()
      this.actionLogs.push(`User apply coupon: ${this.model.coupon_code}`)
      if (!this.model.coupon_code) {
        this.setErrorMessages('クーポンが適用されませんでした。クーポンコードが入力されていません')
      } else {
        this.fetchNewTicket()
      }
    },
    setErrorMessages(messages) {
      if (messages instanceof Array) {
        this.errorMessages = messages
      } else {
        this.errorMessages = [messages]
      }
      scrollToTop()
    },
    fetchNewTicket() {
      this.errorMessages = null
      const payload = {
        eventCode: this.$route.params.code,
        ticketId: this.$route.params.ticket_id,
        quantity: this.model.quantity,
        ticketType: this.model.ticket_type,
        usingPoint: this.model.using_point
      }
      if (this.model.coupon_code) {
        payload.applyCoupon = true
        payload.couponCode = this.model.coupon_code
        payload.firstVisitGuestCouponSessionId = Cookies.get('first_visit_guest_coupon_session_id')
      }
      return this.$store
        .dispatch('purchaseNew', payload)
        .then(res => {
          this.ticket = res.data.ticket
          this.event = res.data.event

          this.model.quantity = normalizeQuantityForTicket({
            currentQuantity: this.model.quantity,
            enabledValues: this.enabledQuantities,
            minCap: this.minQuantityCap
          })
          if (payload.applyCoupon) {
            if (res.data.error_messages) {
              this.model.verified_coupon_code = null
              this.setErrorMessages(`クーポンが適用されませんでした。${res.data.error_messages}`)
            } else {
              this.model.verified_coupon_code = payload.couponCode
              scrollTo(this.$refs.priceDataElement)
            }
          } else if (res.data.error_messages) {
            this.setErrorMessages(res.data.error_messages)
          }
        })
        .catch(() => {
          this.setErrorMessages('システムエラーが発生しました。もう一度やってみてください！')
        })
    },
    async toPurchaseConfirm(e) {
      if (e) e.preventDefault()
      if (!this.canGoToConfirmPage) return

      // 名前入力が必要な場合のバリデーション
      if (this.user.needs_name_register) {
        const profile = this.$refs.userProfileForm.profile
        this.nameForm.family_name = profile.family_name
        this.nameForm.given_name = profile.given_name

        // UserProfileFormの既存のvalidateUserProfileメソッドを使用
        const errorMessages = this.$refs.userProfileForm.validateUserProfile()
        if (errorMessages.length != 0) {
          this.setErrorMessages('お名前を正しく入力してください')
          return
        }
      }

      // 通常の確認画面遷移処理（モーダル表示対象外またはモーダル処理後）
      if (this.model.coupon_code || this.model.verified_coupon_code) {
        if (!this.model.coupon_code) this.model.coupon_code = this.model.verified_coupon_code
        await this.fetchNewTicket()
        if (this.errorMessages) return
      }

      if (this.postedPaymentMethod !== 'amazon_pay') {
        this.clearPendingNameStorage()
      }
      if (this.model.payment_method === 'stripe_cc') {
        const stripeCreditCardRef = this.$refs.PaymentMethods.$refs.stripeCreditCardRef

        const { error, confirmationToken: stripePaymentToken } = await stripeCreditCardRef.createPaymentToken()
        if (error) return this.setErrorMessages(this.$useI18('errors.default'))

        this.stripePaymentToken = stripePaymentToken
      }

      this.trackIssue616Event('next_button_clicked')

      this.confirm = true
      this.hasVisitedConfirmation = true // 確認画面に進んだことを記録
      const paymentMethod = this.postedPaymentMethod
      const query = { m: paymentMethod.replace(/^ntt_/, '').replace(/^stripe_/, '') }
      query.easy_payment = this.isEasyPayment
      this.pushGtmData()
      this.$router.push({ path: this.$route.path, query })
      this.errorMessages = null
    },
    backToNewPage(data) {
      this.confirm = false
      this.agreeProvideInfo = false
      if (data?.needDisableCardEasyPayment) {
        this.user.active_setup_intent_exists = false
      }
      if (data?.errorMessage) {
        this.setErrorMessages(data.errorMessage)
      }
    },
    showAndHideTooltip() {
      this.displayTooltip = true
      setTimeout(() => {
        this.displayTooltip = false
      }, 5000)
    },
    pushGtmData() {
      const gtm = new GTM(this.$route, this.$store)
      GTM.pushData(gtm.defaultData)
      const productList = [{ id: `${this.event.id}`, price: `${this.purchasePrice}`, quantity: `${this.model.quantity}` }]
      if (this.model.ticket_type === 'konkatsu_freepass') {
        productList.push({ id: `${this.konkatsuFreePassId}`, price: `${this.ticket.konkatsu_freepass_ticket_price}`, quantity: '1' })
        this.localStorage.setItem(this.purchaseProductsKey, JSON.stringify(productList))
      }
      GTM.pushData({
        PageType: 'Basketpage',
        HashedEmail: this.gtmDatalayer.hashed_email,
        ProductBasketProducts: productList,
        Ui_userlv: this.gtmDatalayer.ui_userlv
      })
      GTM.trackingPageView(this.$route)
    },
    onUpdateAgreeProvideInfo(value) {
      this.agreeProvideInfo = value
    },

    // 回数券モーダル関連のメソッド
    shouldShowRepeatDiscountModal() {
      // 基本条件：ログイン済み && 回数券対象ユーザー && 確認画面に一度も進んでいない
      if (!this.$store.isLoggedIn || !this.user?.eligible_for_repeat_discount || this.hasVisitedConfirmation) {
        return false
      }

      // A/Bテストの結果でBパターン（テストグループ）の場合のみモーダル表示
      if (this.repeatDiscountABTest.isBPattern) {
        return true
      } else if (this.repeatDiscountABTest.isAPattern) {
        return false
      }

      return false
    },

    closeRepeatDiscountModal() {
      // モーダルを閉じた場合は回数券なし（チェックボックスOFF）
      this.includeRepeatDiscount = false
      this.model.include_repeat_discount = false
    },

    handlePurchaseWithRepeatDiscount() {
      this.includeRepeatDiscount = true
      this.model.include_repeat_discount = true
      // モーダルで「追加する」を選択した場合、チェックボックスが自動的にONになる
    },

    handlePurchaseWithoutRepeatDiscount() {
      this.includeRepeatDiscount = false
      this.model.include_repeat_discount = false
      // モーダルで「追加しない」を選択した場合、チェックボックスが自動的にOFFになる
    }
  }
}
</script>

<style lang="scss" scoped>
.noticeText {
  font-size: 1rem;
  color: $gray-55;
  &-link {
    color: $black-1a;
    font-weight: bold;
    cursor: pointer;
    text-decoration: underline;
  }
}

.fontNormal {
  font-weight: normal;
}

.purchaseButton {
  text-align: center;
  padding: 1rem 0;
  font-weight: bold;
  &.disabled {
    background-color: $gray-c6;
  }
}

.priceData {
  &-tpInput {
    width: 108px;
    text-align: right;
  }
  &-item {
    @include flex;
    position: relative;
    justify-content: space-between;
    border-bottom: 1px solid $gray-c6;
    font-size: 1.2rem;
    color: $gray-55;
    &-note {
      padding: 8px;
      font-size: 1rem;
    }
    &-desc {
      text-align: right;
      select {
        color: $black-1a;
        max-width: 100px;
        height: 32px;
        font-size: 1.4rem;
      }
      .price {
        font-size: 1.6rem;
        color: $pink-thin;
        font-weight: 900;
      }
      .originPrice {
        padding-right: 5px;
        text-decoration: line-through;
      }
    }
    &-tooltip {
      position: absolute;
      width: 85%;
      bottom: 50px;
      right: 0;
      padding: 0.8rem 1rem 0.6rem;
      border-radius: 3px;
      background-color: $gray-55;
      color: $white;
      box-shadow: 0 3px 6px 0 rgba($black, 0.3);
      z-index: 1;
      font-size: 1.4rem;
      @media screen and (min-width: 960px) {
        width: 35%;
      }
      &::before,
      &::after {
        display: block;
        position: absolute;
        background-color: $gray-55;
        content: '';
      }
      &::before {
        right: 50px;
        bottom: -8px;
        width: 24px;
        height: 24px;
        transform: rotate(45deg);
        border-radius: 3px;
        box-shadow: 0 3px 6px 0 rgba($black, 0.3);
        z-index: 2;
      }
      &::after {
        right: 42px;
        bottom: 0;
        width: 40px;
        height: 20px;
        z-index: 3;
      }
      &-inner {
        position: relative;
        z-index: 10;
      }
    }
    &-group-discount {
      width: fit-content;
      padding: 2px;
      border-radius: 2px;
      background: $pink-thin;
      font-size: 1rem;
      font-weight: 700;
      text-align: right;
      color: $white;
    }
  }
}

.purchaseExtra {
  margin: 1rem 0;
  font-size: 1.2rem;
  color: $base-light;
}

.paymentType {
  &:not(:last-child) {
    border-bottom: 1px solid $gray-c6;
  }
  position: relative;
  &-label {
    font-weight: bold;
    color: $gray-80;
    @include flex;
    justify-content: flex-start;
    padding: 1rem;
    margin: 0.8rem 0;
    transition: 0.2s;
    &-radio {
      min-width: 11px;
      height: 11px;
      margin: auto 1.2rem auto 0.6rem;
      background: $white;
      box-shadow: 0 0 0 4px $black-01;
      border-radius: 10px;
      transition: 0.2s;
    }
  }
  &-input {
    display: none;
    &:checked + .paymentType-label {
      color: $black-1a;
      .paymentType-label-radio {
        background: $positive-green-light;
        box-shadow: 0 0 0 4px $positive-green-dark;
      }
    }
  }
}

.cancelLink {
  font-size: 1.2rem;
  text-decoration: none;
  color: $gray-55;
  border: none;
  background: none;
  cursor: pointer;
}

.fade-enter {
  &-from {
    opacity: 0;
    background-color: $foundation-success-light;
  }
  &-active {
    transition:
      opacity 0.4s linear,
      background-color 1s linear;
  }
  &-to {
    background-color: $white;
  }
}

.pageTitle {
  border-bottom: 2px solid $gray-c6;
  font-size: 1.8rem;
  text-align: center;
  &--no-border {
    border-bottom: none;
  }
}

.purchaseCard {
  &-tpLogo {
    display: flex;
    align-items: center;
    &-text {
      font-size: 16px;
      color: $black-1a;
      font-weight: bold;
    }
  }
  &-tpPoint {
    position: absolute;
    right: 20px;
    color: $black-1a;
    font-weight: bold;
  }
  &-event {
    font-size: 1.2rem;
    position: relative;
    &-box {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      font-size: 1.6rem;
      font-weight: bold;
      &-eyecatch {
        max-height: 50px;
        display: inline-block;
      }
      &-block {
        display: inline-block;
        padding-left: 10px;
        &-today {
          display: inline-block;
          padding: 2px 5px 0;
          border: 1px solid #ea2e4b;
          color: #ea2e4b;
          font-size: 1rem;
        }
        &-area {
          font-size: 1rem;
        }
      }
    }
    &-title {
      font-weight: bold;
      color: $gray-55;
    }
  }
  &-subscription {
    font-size: 1.2rem;
    font-weight: bold;
  }
  &-priceData {
    font-size: 1.2rem;
    border-top: 1px solid $gray-c6;
    font-weight: bold;
    &--pattern-b {
      border-top: none;
      padding: 16px 20px;
    }
  }
  &-subtext {
    color: $gray-55;
    font-size: 1rem;
  }
}

.purchaseForm {
  margin: 15px;
}

.event-info {
  background-color: $gray-f1;
}

.card-layout {
  border-radius: 12px;
  border-style: none;
  box-shadow: 0px 0px 3px 0px #00000040;
}

.card-layout--no-shadow {
  box-shadow: none;
}
</style>
